require('../javascript/new_ds/style/tailwind_input.css')
